import { PropsWithChildren } from 'react'
import { HeaderProps } from 'react-table'
import clsx from 'clsx'
import { useKhipu } from '../../../hooks/useKhipu'

interface MultiField {
  name: string
  label: string
  type?: 'text' | 'date' | 'time'
  placeholder?: string
  width?: string
}

interface Props<T extends object> {
  tableProps: PropsWithChildren<HeaderProps<T>>
  fields: MultiField[]
  className?: string
}

const KTableHeaderMulti = <T extends object>({
  tableProps,
  fields,
  className,
}: Props<T>) => {
  const { searchValues, changeSearchValues } = useKhipu()

  const handleFieldChange =
    (fieldName: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
      changeSearchValues({
        ...searchValues,
        [fieldName]: e.target.value,
      })
    }

  return (
    <th {...tableProps.column.getHeaderProps()} className={clsx(className)}>
      <div className='d-flex gap-3 flex-wrap'>
        {fields.map((field) => (
          <div key={field.name} className='d-flex flex-column'>
            {/* Label del input */}
            <div className='fw-bold mb-1'>{field.label}</div>
            {/* Input */}
            <input
              type={field.type || 'text'}
              name={field.name}
              placeholder={field.placeholder}
              value={searchValues[field.name] || ''}
              onChange={handleFieldChange(field.name)}
              className='form-control form-control-solid bg-white border border-gray-300'
              style={{ width: field.width || '150px' }}
            />
          </div>
        ))}
      </div>
    </th>
  )
}

export { KTableHeaderMulti }